/* =============================================================
 * import
 * ========================================================== */

/* =============================================================
 * function
 * ========================================================== */

import {featuresSwiper, nextOneSwiper, upcomingSwiper, handlingSwiper} from "../modules/swiper";

export default function exe(data) {
  featuresSwiper(data);
  nextOneSwiper(data);
  handlingSwiper(data);
  upcomingSwiper(data);

  /*
  const namespace = data.current.namespace; // barbajsからdataを取得
  // 遷移元ページが存在しない場合（TOPページにランディングした場合）のみ実行
  if (namespace === '') {
    console.log('top landing');
  }
  */
}
